var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack516({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.15,12.78V7.06h3.92V8H7.3V9.38H9.69v1H7.3v2.43Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack516);
export default __webpack_public_path__ + "static/media/Symbolpack_5_16.19b8468d378cd13c1270574d4dc18cf9.svg";
export { ForwardRef as ReactComponent };